import "core-js/modules/es.array.push.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "list"
};
const _hoisted_2 = {
  key: 0,
  class: "mt-4 w-full flex items-center justify-between"
};
const _hoisted_3 = {
  key: 0,
  class: "flex items-center gap-2"
};
const _hoisted_4 = {
  key: 0,
  class: "text-[#f00] text-xs"
};
const _hoisted_5 = {
  key: 1,
  class: "absolute bottom-0 w-full flex flex-col pt-2 pb-2 border-t border-t-[#E9EBF2]"
};
const _hoisted_6 = {
  class: "flex justify-center mb-2"
};
const _hoisted_7 = {
  class: "text-[#86909C] text-sm flex items-center justify-center gap-1"
};
const _hoisted_8 = {
  class: "text-[#165DFF]"
};
const _hoisted_9 = {
  key: 0,
  class: "text-[#f00] text-xs"
};
import { computed, ref, provide, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import useMainStore, { storeToRefs } from '../../main.store';
import useAppStore from '@views/app.store';
import modules from '../media/create';
import { pubWorkflow } from '../../api';
import { articlePubOfficeMedia, batchCheckBannedWords } from '@/views/home/knowledge/api/index';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'PublishCreate'
  },
  __name: 'PublishCreate',
  props: {
    item: {},
    content: {},
    isHome: {
      type: Boolean
    }
  },
  emits: ["publish", "refresh", "bannedWordsUpdated"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emits = __emit;
    const props = __props;
    const appStore = useAppStore();
    const mainStore = useMainStore();
    const {
      messageContentMap
    } = storeToRefs(mainStore);
    const messageContent = ref([]);
    const info = ref({
      articleDetails: [],
      pubPlanDetails: null
    });
    // 响应式数据
    const activeTab = ref(2);
    // const isSubmitting = ref(false)
    const tabRefs = ref({});
    const btnLoading = ref(false);
    // Tab 配置
    const tabOptions = ref([{
      label: '权威媒体',
      value: 2,
      productID: 14,
      component: 'Tab1',
      userInfo: {}
    }, {
      label: '臻选媒体',
      value: 3,
      productID: 46,
      component: 'Tab2',
      userInfo: {}
    }, {
      label: '自媒体',
      value: 6,
      productID: 222,
      component: 'Tab2',
      userInfo: {}
    }, {
      label: '联盟新闻',
      value: 4,
      component: 'Tab3',
      userInfo: {}
    }]);
    const availableFiles = ref([]);
    provide('availableFiles', availableFiles);
    const checkingBannedWords = ref(false);
    const checkBannedWords = async () => {
      if (checkingBannedWords.value || btnLoading.value) return;
      const files = [...availableFiles.value];
      const ids = [...new Set(files.map(file => file.id).filter(id => id != null))];
      if (!ids.length) {
        ElMessage.warning('暂无可检测的文章');
        return;
      }
      checkingBannedWords.value = true;
      try {
        const res = await batchCheckBannedWords({
          ids
        });
        if (!Array.isArray(res.data)) throw new Error('检测结果格式错误');
        const results = new Map(res.data.map(result => [String(result.id), result]));
        let failed = 0;
        let blocked = 0;
        files.forEach(file => {
          const result = results.get(String(file.id));
          if (!result || result.message || typeof result.checkPass !== 'boolean') {
            failed++;
            return;
          }
          if (result.checkPass) {
            file.bannedWords = '';
          } else if (Array.isArray(result.bannedWords) && result.bannedWords.length) {
            file.bannedWords = JSON.stringify(result.bannedWords);
            blocked++;
          } else {
            failed++;
          }
        });
        emits('bannedWordsUpdated', files);
        if (failed) {
          ElMessage.warning(`检测完成，${blocked} 篇存在违禁词，${failed} 篇未能完成检测，请重试`);
        } else if (blocked) {
          ElMessage.warning(`检测完成，${blocked} 篇文章存在违禁词，请处理`);
        } else {
          ElMessage.success('检测完成，未发现违禁词');
        }
      } catch {
        ElMessage.error('违禁词检测失败，请稍后重试');
      } finally {
        checkingBannedWords.value = false;
      }
    };
    provide('batchBannedWordCheck', {
      visible: computed(() => props.isHome),
      loading: checkingBannedWords,
      disabled: computed(() => btnLoading.value || !availableFiles.value.length),
      check: checkBannedWords
    });
    const isPlan = computed(() => {
      if (props.isHome) {
        return false;
      }
      return props.item.messageType === 319;
    });
    const editable = computed(() => {
      return props.item.id === mainStore.lastMsgId && !isPlan.value;
    });
    const totalUseCount = computed(() => {
      let ret = 0;
      Object.values(tabRefs.value).forEach(component => {
        if (component && typeof component.useCount !== 'undefined') {
          ret += component.useCount;
        }
      });
      return ret;
    });
    // 统一提交所有表单数据
    const handleSubmit = async () => {
      if (checkingBannedWords.value) return;
      const pubPlanDetails = [];
      availableFiles.value.forEach(item => {
        if (item.authoritativeMediaId || item.newsSource || item.selectedMediaIds?.length || item.selfMediaIds?.length) {
          const data = {
            ...item,
            articleFileId: item.id
          };
          if (props.isHome) {
            data.articleFileId = item.fileId;
          }
          pubPlanDetails.push(data);
        }
      });
      if (!pubPlanDetails.length) {
        ElMessage.warning('还未选择需要发布的文章，请选择后再进行发布操作！');
        return;
      }
      if (!props.isHome && pubPlanDetails.some(x => x.bannedWords)) {
        ElMessage.warning('您发布的部分文章存在违禁词未处理，请先处理！');
        return;
      }
      const text = `是否确认执行当前发布计划?<div>确认发布计划后将会立即按照发布计划进行发布操作，是否继续？</div>`;
      try {
        await ElMessageBox.confirm(text, '', {
          customClass: 'keyword-verify-confirm',
          dangerouslyUseHTMLString: true,
          confirmButtonText: '立即执行',
          cancelButtonText: '先不执行',
          type: 'warning'
        });
      } catch (e) {
        return;
      }
      const params = {
        optType: 'Gen_PUB_PLAN',
        pubPlanDetails
      };
      if (!props.isHome) {
        params.sessionId = mainStore.msgParams.sessionId;
        params.updateMessageId = props.item.id;
      }
      try {
        btnLoading.value = true;
        const func = props.isHome ? articlePubOfficeMedia : pubWorkflow;
        await func(params);
        info.value.pubPlanDetails = pubPlanDetails;
        ElMessage.success('提交成功');
        emits('publish');
      } catch (error) {
        if (props.isHome && error?.code === 511) {
          emits('refresh');
          return;
        }
        console.error('API调用失败:', error);
      } finally {
        btnLoading.value = false;
      }
    };
    // 设置 tab 引用
    const setTabRef = (component, el) => {
      if (el) {
        tabRefs.value[component.value] = el;
      }
    };
    // Tab 切换处理
    const handleTabChange = async tabName => {
      activeTab.value = tabName;
    };
    const handleRefresh = () => {
      emits('refresh');
    };
    handleTabChange(2);
    const getLabel = item => {
      let ret = `${item.label}`;
      const tab = tabRefs.value[item.value];
      if (tab) {
        ret += `(预计消耗${tab.useCount}点)`;
      }
      return ret;
    };
    onMounted(() => {
      if (props.isHome) {
        return;
      }
      console.log('props', props, messageContentMap);
      try {
        if (props.content) {
          info.value = props.content;
          console.log('info', info.value);
          availableFiles.value = info.value.articleDetails.map(item => item.articleFileIds).flat();
          messageContent.value = messageContentMap.value[props.item.id] || [];
          if (info.value.pubPlanDetails) {
            info.value.pubPlanDetails.forEach(item => {
              const fileIndex = availableFiles.value.findIndex(file => file.id === item.articleFileId);
              if (fileIndex !== -1) {
                // 将 pubPlanDetails 中的数据合并到对应的文件对象中
                availableFiles.value[fileIndex] = {
                  ...item
                };
              }
            });
          }
          if (info.value.articleDetails) {
            info.value.articleDetails.forEach(item => {
              item.articleFileIds.forEach(file => {
                const attach = messageContent.value.find(son => son.id === file.id);
                file.animationText = attach ? attach.strFileContent : '';
                file.text = file.animationText;
              });
            });
          }
        }
        mainStore.loadNextMsg(props.item);
      } catch (error) {
        debugger;
        info.value = {
          articleDetails: []
        };
        console.log(error);
      }
    });
    __expose({
      availableFiles
    });
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_button = _resolveComponent("el-button");
      const _component_Warning = _resolveComponent("Warning");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["publish relative", {
          isHome: props.isHome
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tabs, {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeTab.value = $event),
        onTabChange: handleTabChange,
        class: "w-full h-full mt-3"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabOptions.value, item => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.value,
            label: getLabel(item),
            name: item.value,
            class: "h-full pr-6 overflow-y-auto"
          }, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(modules)[item.component]), {
              ref_for: true,
              ref: el => setTabRef(item, el),
              key: item.value,
              isPlan: isPlan.value,
              data: item,
              onRefresh: handleRefresh
            }, null, 40, ["isPlan", "data"]))]),
            _: 2
          }, 1032, ["label", "name"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), !props.isHome ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", null, _toDisplayString(info.value.pubPlanDetails ? `本次发布预计消耗${totalUseCount.value}点，实际消耗以发布成功为准` : ' '), 1), !info.value.pubPlanDetails ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", null, "本次发布预计消耗" + _toDisplayString(totalUseCount.value) + "点", 1), _unref(appStore).surplusNum < totalUseCount.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, "权益不足，请联系客成购买")) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        loading: btnLoading.value,
        type: "primary",
        class: "render-btn",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(btnLoading.value ? '发布计划提交中' : '确认发布计划'), 1)]),
        _: 1
      }, 8, ["loading"])])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
        type: "primary",
        loading: btnLoading.value,
        disabled: checkingBannedWords.value,
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 检测并发布 ", -1)]))]),
        _: 1
      }, 8, ["loading", "disabled"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Warning)]),
        _: 1
      }), _createElementVNode("div", null, [_cache[2] || (_cache[2] = _createTextVNode("本次发布预计消耗", -1)), _createElementVNode("span", _hoisted_8, _toDisplayString(totalUseCount.value), 1), _cache[3] || (_cache[3] = _createTextVNode("点", -1))]), _unref(appStore).surplusNum < totalUseCount.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, "权益不足，请联系客成购买")) : _createCommentVNode("", true)])]))], 2);
    };
  }
});